import { DEFAULT_GEMINI_USAGE_LEVEL_CONFIG } from '@workalizer/shared/lib/gemini-usage-level/config';
import { addDays, differenceInCalendarDays, format, isValid, parseISO } from 'date-fns';
/**
 * Any selected range is rounded down to complete weeks from the start date.
 * Thresholds and activity both use only that truncated window.
 */
export var resolveGeminiUsageLevelPeriod = function (dateFrom, dateTo, config) {
    if (config === void 0) { config = DEFAULT_GEMINI_USAGE_LEVEL_CONFIG; }
    var start = parseISO(dateFrom);
    var end = parseISO(dateTo);
    if (!isValid(start) || !isValid(end) || end < start) {
        return { isValid: false };
    }
    var days = differenceInCalendarDays(end, start) + 1;
    var weekCount = Math.floor(days / config.periodLengthDays);
    if (weekCount < 1) {
        return { isValid: false };
    }
    var effectiveDateTo = format(addDays(start, weekCount * config.periodLengthDays - 1), 'yyyy-MM-dd');
    return {
        isValid: true,
        weekCount: weekCount,
        effectiveDateFrom: dateFrom,
        effectiveDateTo: effectiveDateTo
    };
};
